module.exports = __webpack_public_path__ + "static/media/lock_screen___notification@2x.7dcf276b.png";